import React from 'react';
import {
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  btn: {
    minWidth: 142,
    fontFamily: 'Vietnam',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    padding: '10px 0px',
    height: '36px',
  },
  btnGreen: {
    background: 'var(--green)',
    color: '#fff',
    '&:hover': {
      background: 'var(--green)',
      color: '#fff',
    },
  },
  btnGray: {
    background: 'var(--lightGray)',
    color: 'var(--darkBleu)',
  },
}));
const Btn = ({ variation, children, onClick, style, disabled }) => {
  const classes = useStyles();
  let styling = classes.btnGray;
  if (variation === 'primary') {
    styling = classes.btnGreen;
  }

  return (

    <Button disabled={disabled} className={`${classes.btn} ${styling}`} onClick={onClick} style={style}>
      {children}
    </Button>
  );
};

export default Btn;
